
export function sendOpenPopupEvent (ga4Data) {
    dataLayer.push(ga4Data);
}